import Testimony5 from "../../assets/images/testimonyImages/5.webp";
import Testimony1 from "../../assets/images/testimonyImages/1.webp";
import Testimony2 from "../../assets/images/testimonyImages/2.webp";
import Testimony3 from "../../assets/images/testimonyImages/3.webp";
import Testimony4 from "../../assets/images/testimonyImages/4.webp";

export const TESTIMONIES = [
  {
    id: 1,
    image: Testimony5,
    shortText:
      "I recently had the unfortunate experience of fracturing my right elbow, and I was introduced to this advanced immobilization system...",
    fullText: `
I recently had the unfortunate experience of fracturing my right elbow, and I was introduced to this advanced 3D-printed immobilization system as an alternative to a traditional plaster cast.

From day one, the difference was obvious. The cast was lightweight, breathable, and fit my arm perfectly. Unlike conventional casts, there was no itching, sweating, or discomfort. I could shower without worry and continue my daily routine with confidence.

What impressed me most was the precision. The fit felt medically accurate yet comfortable, giving me full support without making my arm feel trapped. Even during long hours, I experienced no pain or irritation.

This technology truly represents the future of orthopedic care. It made my recovery smoother, faster, and far more comfortable than I ever expected.
`,
  },
  {
    id: 2,
    image: Testimony1,
    shortText:
      "This revolutionary immobilization system is truly a game-changer compared to traditional casts.",
    fullText: `
This revolutionary immobilization system is truly a game-changer. Having used traditional plaster casts in the past, I was skeptical at first, but this experience completely changed my perception.

The design is modern, breathable, and incredibly lightweight. There was no stiffness, no odor, and no skin irritation. I could move around comfortably without constantly being reminded that I was wearing a cast.

It felt less like a medical device and more like a thoughtfully designed product focused on patient comfort. I would highly recommend this solution to anyone looking for a smarter, more comfortable recovery option.
`,
  },
  {
    id: 3,
    image: Testimony2,
    shortText:
      "Finally, an immobilization solution that doesn’t feel like a burden during recovery.",
    fullText: `
Finally, an immobilization solution that doesn’t feel like a burden. From the moment I wore it, I noticed how breathable and ergonomic it was.

Unlike traditional casts that restrict movement and cause discomfort, this system allowed my skin to breathe and my arm to stay dry. The custom fit ensured stability without unnecessary pressure.

Recovery can already be stressful, but this product made the process far more manageable. It’s reassuring to see innovation being applied so thoughtfully in healthcare.
`,
  },
  {
    id: 4,
    image: Testimony3,
    shortText:
      "I’m genuinely impressed by the innovation and patient-first approach behind this product.",
    fullText: `
I’m genuinely impressed by the innovation behind this product. It’s clear that a lot of thought went into both medical precision and patient comfort.

The cast felt secure yet flexible enough to avoid the rigid discomfort of plaster. It didn’t interfere with daily activities and looked far more modern and hygienic.

This is exactly the kind of innovation patients need—solutions that heal without adding unnecessary discomfort. An excellent step forward in orthopedic care.
`,
  },
  {
    id: 5,
    image: Testimony4,
    shortText:
      "As someone who has experienced multiple casts before, this was by far the most comfortable.",
    fullText: `
As someone who has experienced multiple casts over the years, this was by far the most comfortable immobilization system I’ve ever used.

The lightweight structure, breathable design, and precise fit made a huge difference in my recovery experience. I didn’t have to deal with constant itching or heaviness, which is usually unavoidable with traditional casts.

This system allowed me to focus on healing rather than discomfort. I truly believe this is the future of orthopedic immobilization.
`,
  },
];
